/**
 * In-memory store for the /config admin shared secret.
 *
 * Held in module scope so it survives navigation between admin sub-pages
 * but is wiped on tab close. Never persisted to localStorage / cookies —
 * forcing re-entry on every fresh session is a deliberate choice.
 */
let activeConfigKey: string | null = null;

export function getActiveConfigKey(): string | null {
  return activeConfigKey;
}

export function setActiveConfigKey(key: string | null): void {
  activeConfigKey = key && key.trim() ? key.trim() : null;
}
